import angular from 'angular';
import uiRouter from 'angular-ui-router';
import nonRacingEventsComponent from './nonRacingEvents.component';

let nonRacingEventsModule = angular.module('nonRacingEvents', [
  uiRouter
])

.component('nonRacingEvents', nonRacingEventsComponent)

.name;

export default nonRacingEventsModule;
